var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/seo-macro.j2"] = require( "macros/seo-macro.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-seo-copy.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/seo-macro.j2", false, "category/templates/category-seo-copy.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("buildSeo")) {
var t_4 = t_1.buildSeo;
} else {
cb(new Error("cannot import 'buildSeo'")); return;
}
context.setVariable("buildSeo", t_4);
var t_5;
t_5 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch") || !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"))?{}:runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug")));
frame.set("navItem", t_5, true);
if(frame.topLevel) {
context.setVariable("navItem", t_5);
}
if(frame.topLevel) {
context.addExport("navItem", t_5);
}
var t_6;
t_6 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isSearch")?runtime.contextOrFrameLookup(context, frame, "None"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"seo"));
frame.set("seo", t_6, true);
if(frame.topLevel) {
context.setVariable("seo", t_6);
}
if(frame.topLevel) {
context.addExport("seo", t_6);
}
output += "<div class=\"dom-seo-copy\">";
if(runtime.contextOrFrameLookup(context, frame, "seo") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "seo")),"seoCopy") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isFilterSelected")) {
output += "<div class=\"o-row\">";
if(runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "pageType"),["GATEWAY_NN","OLAPIC","NO_NAV"]) || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") != "category" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") == 0)) {
output += "\n\n            <div class=\"o-column o-extra-small--12 o-seo-copy\">";
;
}
else {
output += "\n\n            <div class=\"o-column o-extra-small--12 o-medium--9 o-medium--offset-3 o-large--10 o-large--offset-2 o-seo-copy o-seo-copy--extra-padding\">";
;
}
output += "\n\n                ";
output += runtime.suppressValue((lineno = 23, colno = 25, runtime.callWrap(t_4, "buildSeo", context, [runtime.contextOrFrameLookup(context, frame, "navItem")])), env.opts.autoescape);
output += "\n\n            </div>\n\n        </div>";
;
}
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-seo-copy.j2"] , dependencies)